import { assembleExperimentPack } from "../../../physics-experiment/src/data/pack-loader.js";
import type {
  AssessmentConfig,
  ExperimentMeta,
  ExperimentPack,
  KnowledgeItem,
  MissionDefinition,
} from "../../../physics-experiment/src/data/schemas.js";

const experimentModules = import.meta.glob("../../experiments/*/experiment.json", { eager: true }) as Record<
  string,
  { default: ExperimentMeta }
>;
const missionModules = import.meta.glob("../../experiments/*/mission.json", { eager: true }) as Record<
  string,
  { default: MissionDefinition }
>;
const rulesModules = import.meta.glob("../../experiments/*/rules.json", { eager: true }) as Record<
  string,
  { default: unknown[] }
>;
const knowledgeModules = import.meta.glob("../../experiments/*/knowledge.json", { eager: true }) as Record<
  string,
  { default: KnowledgeItem[] }
>;
const assessmentModules = import.meta.glob("../../experiments/*/assessment.json", { eager: true }) as Record<
  string,
  { default: AssessmentConfig }
>;

function slugFromPath(path: string): string {
  const match = /experiments\/([^/]+)\//.exec(path);
  if (!match) {
    throw new Error(`[pack-loader] 无法从路径解析实验 slug：${path}`);
  }
  return match[1];
}

function indexBySlug<T>(modules: Record<string, { default: T }>): Map<string, T> {
  const map = new Map<string, T>();
  for (const [path, mod] of Object.entries(modules)) {
    map.set(slugFromPath(path), mod.default);
  }
  return map;
}

export function listExperimentSlugs(): string[] {
  return [...indexBySlug(experimentModules).keys()];
}

export function loadExperimentPack(slug: string): ExperimentPack {
  const experiment = indexBySlug(experimentModules).get(slug);
  const mission = indexBySlug(missionModules).get(slug);
  const rules = indexBySlug(rulesModules).get(slug) ?? [];
  const knowledge = indexBySlug(knowledgeModules).get(slug) ?? [];
  const assessment = indexBySlug(assessmentModules).get(slug);

  if (!experiment || !mission || !assessment) {
    throw new Error(`[pack-loader] 实验包不完整：${slug}`);
  }

  return assembleExperimentPack({ experiment, mission, rules, knowledge, assessment });
}
